import { useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'

// Memoized selector that only returns a new array when the games object actually changes
const selectActiveGames = createSelector(
  [(state) => state.gameTable.games],
  (games) => Object.keys(games)
)

export default function useActiveGames() {
  const activeGames = useSelector(selectActiveGames);

  if (activeGames?.length === 0 || !activeGames) {
    return []
  }

  return activeGames
}